import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: no-preference)';

const getInitialState = (): boolean => !window.matchMedia(QUERY).matches;

/**
 * To check the systems animation effects ON/OFF
 * @returns boolean
 */

export const usePrefersReducedMotion = (): boolean => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState<boolean>(getInitialState);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY);

    const listener = (event: { matches: boolean }): void => setPrefersReducedMotion(!event.matches);

    mediaQueryList.addEventListener('change', listener);

    return (): void => mediaQueryList.removeEventListener('change', listener);
  }, []);

  return prefersReducedMotion;
};
